import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Grid, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Snackbar from "@material-ui/core/Snackbar";

import { registerUser } from "../../actions/authActions";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
    marginBottom: 20,
    transition: "box-shadow 0.2s ease-in-out",
    "& label.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "&:focus": {
      boxShadow: `0 0 5px ${theme.palette.primary.main}`,
    },
  },

  formContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    boxShadow: theme.shadows[3],
    padding: 20,
  },

  formTitle: {
    fontSize: "2rem",
    fontWeight: 500,
    fontFamily: "Montserrat, sans-serif",
    color: theme.palette.text.primary,
  },

  submitButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: "0.5rem 2rem",
    borderRadius: "0.25rem",
    boxShadow: theme.shadows[2],
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    width: "100%",
    marginBottom: "1rem",
  },

  btnBlock: {
    textAlign: "center",
    marginTop: "1rem",
  },

  loginLink: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const Register = ({ history }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const classes = useStyles();
  const dispatch = useDispatch();
  const errorsFromStore = useSelector((state) => state.errors);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const registrationSuccess = useSelector((state) => state.auth);

  useEffect(() => {
    if (errorsFromStore) {
      setErrors(errorsFromStore);
    }
  }, [errorsFromStore]);

  const handleChange = (e) => {
    if (e.target.name === "login") {
      setLogin(e.target.value);
    } else if (e.target.name === "password") {
      setPassword(e.target.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const userData = {
      email: "mail@mail.com",
      login,
      password,
    };

    handleSnackbarClose();
    dispatch(registerUser(userData, history));
  };

  const handleLoginPush = () => {
    history.push("/login");
  }

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
    history.push("/login");
  };

  return (
    <Grid container justifyContent="center" style={{ alignItems: "center" }}>
      <Grid item xs={12} sm={8} md={6} lg={4}>
        <Paper className={classes.formContainer}>
          <Typography className={classes.formTitle}>
            Create an Account
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              type="text"
              name="login"
              value={login}
              onChange={handleChange}
              className={classes.textField}
              helperText={errors.login ? errors.login : ""}
              error={errors.login ? true : false}
            />
            <TextField
              label="Password"
              type="password"
              name="password"
              value={password}
              onChange={handleChange}
              className={classes.textField}
              helperText={errors.password ? errors.password : ""}
              error={errors.password ? true : false}
            />

            <div className={classes.btnBlock}>
              <Button
                className={classes.submitButton}
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
            </div>

            <div className="p-4 mb: p-0 mb: pt-4">
              <Typography>
                <Button onClick={handleLoginPush} className={classes.loginLink}>
                  Already have an account? Login
                </Button>
              </Typography>
            </div>
          </form>

          <Snackbar
            open={showSnackbar}
            message="Registration successful! Please login."
            action={
              <>
                <Button
                  color="secondary"
                  size="small"
                  onClick={handleSnackbarClose}
                >
                  LOGIN
                </Button>

                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => setShowSnackbar(false)}
                >
                  <Close />
                </IconButton>
              </>
            }
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withRouter(Register);
